<div class="container-fluid bg-color py-3">
  <div class="row">
    <div class="d-flex align-items-center flex-wrap gap-3 ms-2">
      <div class="search-container">
        <input matInput placeholder="search your classrooms here ..." [(ngModel)]="searchQuery" class="form-control" />
        <mat-icon class="search-icon">search</mat-icon>
      </div>
      <button class="responsive-btn" (click)="openCreateClassDialog()">
        <mat-icon>add</mat-icon>
        <span class="btn-text">Create Classroom</span>
      </button>
      <!-- for now we dont need this... but later will used this
	  <button class="responsive-btn" (click)="openJoinDialogBox()">
        <mat-icon>person_add</mat-icon>
        <span class="btn-text">Join Classroom</span></button>-->
      <div class="notification-section">
        <div class="notification-icon-container">
          <img src="assets/images/bell_notification.svg" alt="notification" class="notification-icon"
            (click)="openNotifications()" />
          <span class="notification-badge" *ngIf="totalNotifications > 0" (click)="markAllNotificationsRead()">{{
            totalNotifications }}</span>
          <div class="notification-slider" [class.open]="isNotificationOpen">
            <div class="notifications-content">
              <app-teachers-notifications (closeSlider)="openNotifications()"
                (totalCountChanged)="updateTotalNotifications($event)" [isSlider]='true'
                [source]="'home'"></app-teachers-notifications>
            </div>
            <hr />
            <a href="teacher-dashboard/notifications" class="sticky-footer">View All</a>
          </div>
        </div>
      </div>

      <div class="profile-sections">
        <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="profile-btn">
          <img src="assets/images/avatar.png" alt="avatar" class="profile-circles" />
        </button>

        <mat-menu #profileMenu="matMenu" class="profile-menu">
          <div class="profile-header" *ngIf="userDetail">
            <p class="name">{{ userDetail.first_name }} {{userDetail.last_name}}</p>
            <p class="email" [matTooltip]="userDetail.phone_email">
              {{ userDetail.phone_email.length > 20 ? (userDetail.phone_email | slice: 0 :20) + '...'
              :userDetail.phone_email }}</p>
          </div>
          <mat-divider></mat-divider>

          <button mat-menu-item [routerLink]="['/teacher-dashboard/profile']" routerLinkActive="active-link">
            <mat-icon>person</mat-icon>
            <span>My Profile</span>
          </button>

          <button mat-menu-item>
            <mat-icon>help_outline</mat-icon>
            <span>Help & Support</span>
          </button>

          <mat-divider></mat-divider>

          <button mat-menu-item class="logout" (click)="logout()">
            <mat-icon color="warn">logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>

      </div>
    </div>
  </div>
</div>

<div class="maincon container-fluid bg-color">
  <div class="row">
    <!-- Left section -->
    <div class="col-sm-12 col-lg-9">
      <div class="main-content mt-3 mb-4 ms-2">
        <div class="flex-space-between">
          <div class="content">
            <h1>Welcome to your intelligent teaching companion</h1>
            <span>Create you first classroom to seamlessly generate personalized courses,</span>
            <span>quizzes and assignments all designed to save time and enhanced learning.</span>
          </div>
          <div class="img-cont">
            <img src="assets/images/banner.png" alt="image" />
          </div>
        </div>
      </div>
      <div class="container">
        <ng-container *ngIf="isLoading; else pageContent">
          <div class="app-spinners">
            <mat-spinner></mat-spinner>
          </div>
        </ng-container>
        <ng-template #pageContent>
          <div class="row">
            <div class="col-md-3 mb-4" *ngFor="let classData of cardData">

              <div class="dashboard-card" (click)="onViewClick(classData.title)">
                <div class="card-content">
                  <div class="card-text">
                    <h4>{{ classData.title || "N/A" }}</h4>
                    <h2>{{ classData.studentCount || 0 }}</h2>
                  </div>
                  <img [src]="classData.image" alt="icon" class="card-icon" />
                </div>

                <h6 class="mt-2 view-link" [ngClass]="{ 'extra-margin': classData.title === 'Active Classrooms' }"
                  (click)="onViewClick(classData.title); $event.stopPropagation()">
                  View
                </h6>
              </div>

            </div>
          </div>
        </ng-template>

      </div>
    </div>

    <!-- Right section -->
    <div class="col-sm-12 col-lg-3 justify-content-center">
      <ng-container *ngIf="userDetail && userDetail.is_tenant_member === true; else userProfileContent">
        <div class="no-classroom-card mt-3 col-12">
          <div class="profile-section">
            <img src="assets/images/avatar.png" alt="Profile" class="avatar" />
            <div class="teacher-info">
              <h5 class="text-start" *ngIf="userDetail">{{ userDetail.first_name }} {{ userDetail.last_name }} </h5>
              <p *ngIf="userDetail" [matTooltip]="userDetail.phone_email">
                {{ userDetail.phone_email.length > 20 ? (userDetail.phone_email | slice :0:20)
                + '...' : userDetail.phone_email }}
              </p>
            </div>
          </div>
          <hr class="custom-divider" />
          <img src="assets/images/profileCard.png" alt="Illustration" class="illustration" />
          <div class="text-start ms-4">
            <p class="no-class-text"> All Your Classrooms in <br /> One Place </p>
            <p class="no-class-subtext">
              View and manage your teaching spaces , quiz , assignments and
              student activities organized just the way you like it.
            </p>
          </div>
          <button class="view-classroom-button" (click)="goToClassroomPage()">View Classroom</button>
        </div>
      </ng-container>

      <ng-template #userProfileContent>
        <div *ngIf="usagePlaneData">
          <div class="no-classroom-card mt-3 col-12">
            <div class="text-start">
              <div class="d-flex">
                <p class="no-class-text plans-color"> Free Plan Limits & Usage</p>
                <img src="assets/images/freePlan.png" alt="classroom" class="ms-3 free-plan" />
              </div>
              <p class="no-class-subtext"> Unlock the Power of AI learning with <br> our Free Plan! Here's what's
                included:</p>
              <div class="profile-section-plans">

                <div class="plan-item">
                  <div class="plan-left">
                    <img src="assets/images/freePlanClassroom.png" alt="classroom" />
                    <div class="text">
                      <p class="title">Classrooms</p>
                      <p class="subtitle">
                        {{usagePlaneData.aggregation.total_active_classrooms}} used of
                        {{usagePlaneData.quota.number_classroom_limit}}
                      </p>
                    </div>
                  </div>
                  <p class="remaining">
                    <span class="remaining-value">
                      {{ usagePlaneData.quota.number_classroom_limit -
                      usagePlaneData.aggregation.total_active_classrooms }}
                    </span>
                    <span class="remaining-text"> left</span>
                  </p>
                </div>

                <div class="plan-item">
                  <div class="plan-left">
                    <img src="assets/images/freePlanStudent.png" alt="classroom" />
                    <div class="text">
                      <p class="title">Students</p>
                      <p class="subtitle">
                        {{usagePlaneData.aggregation.students_enrolled_in_classrooms}} used of
                        {{usagePlaneData.quota.student_limit}}
                      </p>
                    </div>
                  </div>
                  <p class="remaining">
                    <span class="remaining-value">
                      {{usagePlaneData.quota.student_limit -
                      usagePlaneData.aggregation.students_enrolled_in_classrooms}}
                    </span>
                    <span class="remaining-text"> left</span>
                  </p>
                </div>

                <div class="plan-item">
                  <div class="plan-left">
                    <img src="assets/images/freePlanCourse.png" alt="classroom" />
                    <div class="text">
                      <p class="title">AI Courses</p>
                      <p class="subtitle">
                        {{usagePlaneData.aggregation.ai_courses_generated}} used of
                        {{usagePlaneData.quota.monthly_course_limit}}
                      </p>
                    </div>
                  </div>
                  <p class="remaining">
                    <span class="remaining-value">
                      {{usagePlaneData.quota.monthly_course_limit - usagePlaneData.aggregation.ai_courses_generated}}
                    </span>
                    <span class="remaining-text"> left</span>
                  </p>
                </div>

                <div class="plan-item">
                  <div class="plan-left">
                    <img src="assets/images/freePlanQuiz.png" alt="classroom" />
                    <div class="text">
                      <p class="title">Quizzes</p>
                      <p class="subtitle">
                        {{usagePlaneData.aggregation.quiz_creations}} used of
                        {{usagePlaneData.quota.monthly_quiz_limit}}
                      </p>
                    </div>
                  </div>
                  <p class="remaining">
                    <span class="remaining-value">
                      {{usagePlaneData.quota.monthly_quiz_limit - usagePlaneData.aggregation.quiz_creations}} </span>
                    <span class="remaining-text"> left</span>
                  </p>
                </div>
                <hr>
                <div class="course-row mb-1">
                  <p class="title">AI Quiz Questions</p>
                  <span class="remaining-question">10 per quiz</span>
                </div>

                <div class="course-row mb-1">
                  <p class="title">Total Quiz Questions</p>
                  <span class="remaining-question">30 per quiz</span>
                </div>

                <div class="course-row mb-1">
                  <p class="title">Manual Course</p>
                  <span class="remaining-question">Unlimited</span>
                </div>
                <p class="text-center remaining-question mt-2">Ready to scale your classrooms and explore advanced AI
                  tools ?</p>
                <button class="view-classroom-button"
                  [routerLink]="['/teacher-dashboard/upgrade-plan']">Upgrade</button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>